export default __webpack_public_path__ + "static/media/login_logo.f3f03f6d.png";